import { Button, useNotify, useRefresh } from "react-admin";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import AttachmentInput from "server/components/Fields/AttachmentInput";

const UploadDocumentDialog = ({ url, label, hasFile = false }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleUpload = async data => {
    await dataProvider.customRequest(url, { file: data.file }, "PUT", null, true);
    notify("Документът е качен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent={`Качване на файл - ${label}`}
      onConfirm={handleUpload}
      triggerButton={
        <Button
          label="Качи файл"
          variant="contained"
          startIcon={<UploadFileIcon />}
        />
      }
    >
      <AttachmentInput
        source="file"
        label={label}
        placeholder={hasFile ? "Качете нов файл за замяна" : undefined}
        isRequired
      />
    </FormModal>
  );
};

export default UploadDocumentDialog;
